module.exports = __webpack_public_path__ + "static/media/outward.da720276.svg";